//Useful for layouts on Channels, Notfications etc.
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
    details: {
        height: 350,
        marginBottom: 15,
        // overflow:'scroll',
        position: 'relative',
    },
    heading: {
        padding: theme.spacing(3),
    },
    List: {
        maxHeight: 250,
        overflow: 'auto',
        position: 'relative',
    },
    momentsList: {
        maxHeight: 250,
        overflow: 'auto',
        position: 'relative',
    },
    sortableList: {
        listStyle: 'none',
    },
}));
